import React from "react";
import { Pagination, Row, Col } from "antd";
import styles from "./indexPagination.scss";
import { scrollToTop } from "../../services";

const xsOption = { span: 24, offset: 0 };
const smOption = { span: 16, offset: 4 };

function IndexPagination({ total, page, itemPerPage, onPageChange }) {
  const handlePageNumberChange = (pageNumber: number, pageSize: any) => {
    onPageChange(pageNumber, pageSize);
    scrollToTop();
  };

  return (
    <Row>
      <Col xs={xsOption} sm={smOption}>
        <Pagination
          className={`child-center ${styles.pagination}`}
          current={page}
          total={total}
          pageSize={itemPerPage}
          onChange={handlePageNumberChange}
          showQuickJumper
        />
      </Col>
      <Col xs={24} sm={4} md={4} lg={4} xl={4}>
        <p className={styles.total}>
          {page === 1 ? page : (page - 1) * itemPerPage + 1} -{" "}
          {page * itemPerPage} / {total}
        </p>
      </Col>
    </Row>
  );
}

export default IndexPagination;



// WEBPACK FOOTER //
// ./src/components/IndexPagination/IndexPagination.tsx